import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllCustomers(page, limit, query) {
  return httpClient.get(`/merchant/customers?page=${page}&limit=${limit}&query=${query}`);
}

/**
 *
 * @param customerId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getCustomer(customerId) {
  return httpClient.get(`/merchant/customers/${customerId}`);
}

/**
 *
 * @param customerId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteCustomer(customerId) {
  return httpClient.delete(`/merchant/customers/${customerId}`);
}

/**
 *
 * @param customerId
 * @param customer
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateCustomer(customerId, customer) {
  return httpClient.put(`/merchant/customers/${customerId}`, customer);
}

/**
 *
 * @param outlet
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newCustomer(outlet) {
  return httpClient.post('/merchant/customers', outlet);
}

// Merchant Specific APIs ends
// =========================================
